import { useLayout } from '@/providers';
import {DashboardNewUserPage} from "@/pages/dashboards/buddy/new-user";

const DefaultPage = () => {
  const { currentLayout } = useLayout();

  if (currentLayout?.name === 'buddy-layout') {
    return <DashboardNewUserPage />;
  }
};

export { DefaultPage };
